import { web3 } from "@project-serum/anchor";
import type { Adapter } from "@solana/wallet-adapter-base";
import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { useSolanaStore } from "./solanaStore";
import { useCacheStore } from "./cacheStore";
import { IToken, SOL_MINT, SOL_TOKEN, TokenAccountDTO } from "@/shared";

export const useWalletStore = defineStore("wallet", () => {
	// store
	const solanaStore = useSolanaStore();
	const cacheStore = useCacheStore();

	// data
	const wallet = ref<Adapter | null>(null);
	const address = ref<web3.PublicKey>(web3.PublicKey.default);
	const timer = ref<any>(0);

	// methods
	function setWallet(wll: Adapter): void {
		wallet.value = wll;
		address.value = wll.publicKey;

		refreshUserBalance();
	}
	function clearWallet(): void {
		wallet.value = null;
		address.value = null;
	}
	async function refreshUserBalance(): Promise<boolean> {
		if (!isConnected) return false;

		clearTimeout(timer.value);

		timer.value = setTimeout(() => {
			refreshUserBalance();
		}, 10000);

		try {
			const tokens = await solanaStore.tokenClient.getUserTokenIndex(
				address.value
			);

			let wSolBalance = 0;

			for (const token of tokens) {
				const ta = token.account?.data?.parsed?.info?.tokenAmount;
				if (
					(Number(ta?.decimals) === 0 && ta?.amount >= 1) ||
					Number(ta?.amount) === 0
				)
					continue; //NFT

				if (token.account?.data?.parsed?.info.mint === SOL_MINT) {
					wSolBalance = Number(ta.amount);
					continue;
				}

				const account = TokenAccountDTO(token);
				cacheStore.addUserTokenAccount(account);
			}

			const amount = await solanaStore.client.getBalance(address.value);
			cacheStore.addUserTokenAccount({
				...SOL_TOKEN,
				amount: amount + wSolBalance,
			});
		} catch {
			return false;
		}
	}

	async function refreshUserMintBalance(token: IToken) {
		if (address.value == web3.PublicKey.default) {
			return
		}

		let amount = 0;
		if (token.mint == SOL_MINT) {
			amount = await solanaStore.tokenClient.getSolBalance(address.value);
		} else {
			const tokenPDA = solanaStore.tokenClient.getAssociatedTokenPDA(
				token.address,
				address.value,
				token.programID
			);

			console.log("TOKEN", token.programID);

			const giA = await solanaStore.client.getParsedAccountInfo(
				tokenPDA,
				"processed"
			);

			if (giA.value) {
				// @ts-ignore
				amount = Number(giA?.value?.data?.parsed?.info.tokenAmount?.amount);
			}
		}

		cacheStore.updateTokenBalance(token.mint, amount);
	}

	// getters
	const isConnected = computed<boolean>(() => wallet.value !== null);

	// getters
	const isBotWallet = computed<boolean>(() => {
		//@ts-ignore
		return !!wallet.value?.authToken;
	});

	return {
		wallet,
		address,
		isConnected,
		isBotWallet,
		clearWallet,
		setWallet,
		refreshUserBalance,
		refreshUserMintBalance,
	};
});
